import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.componentBackground};
  color: ${({ theme }) => theme.textColor};
`;
